"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.tester.name': 'Nazwa Testera',
    'botTest.tester.model': 'Model AI',
};
